import React, { useRef, useState } from "react";
import { Flex, Image, IconButton, useToast } from "@chakra-ui/react";
import { FaImage } from "react-icons/fa";
import { buildLogoCandidates, nextLogoCandidate, uploadSupplierLogo, validateLogoFile, LOGO_ACCEPT } from "../../../../tools/supplierLogo";

/**
 * Inline logo cell: the current image (walking the static→API candidate list)
 * plus a small upload button. Lifted from the Organisations table pattern and
 * shared by the Suppliers (code), CAMs (CAM_<userid>) and Organisations
 * (ORG_<code>) views — replaces the separate Supplier Logos screen.
 */
const LogoCell = ({ storedCode, label }) => {
  const toast = useToast();
  const fileRef = useRef(null);
  const [bust, setBust] = useState(0);
  const candidates = buildLogoCandidates(storedCode, { cacheBust: bust || undefined, preferApi: bust > 0 });

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const problem = validateLogoFile(file);
    if (problem) {
      toast({ title: "Logo not accepted", description: problem, status: "warning", duration: 5000, isClosable: true });
      return;
    }
    try {
      await uploadSupplierLogo(file, storedCode);
      setBust((n) => n + 1);
      toast({ title: "Logo uploaded", description: `${label || storedCode} logo updated.`, status: "success", duration: 3000, isClosable: true });
    } catch (error) {
      toast({ title: "Logo upload failed", description: error?.response?.data?.message, status: "error", duration: 6000, isClosable: true });
    }
  };

  return (
    <Flex align="center" gap={1}>
      <input ref={fileRef} type="file" accept={LOGO_ACCEPT} style={{ display: "none" }} onChange={onFile} />
      <Image
        key={`${storedCode}-${bust}`}
        src={candidates[0]}
        onError={({ currentTarget }) => nextLogoCandidate(currentTarget, candidates)}
        alt=""
        boxSize="26px"
        borderRadius="4px"
        objectFit="contain"
        border="1px solid"
        borderColor="gray.200"
        bg="white"
      />
      <IconButton icon={<FaImage />} size="xs" variant="ghost" aria-label="Upload logo" title="Upload logo" onClick={() => fileRef.current?.click()} />
    </Flex>
  );
};

export default LogoCell;
